import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import { useTranslation } from 'react-i18next';

const Team = () => {

   const { t } = useTranslation();

   // OwlCarousel Option for Team Members
   const options = {
      0: {
         items: 1,
         margin: 5,
      },
      600: {
         items: 1,
         margin: 5,
      },
      768: {
         items: 2, //3
      },
      992: {
         items: 2, //3
      },
      1000: {
         items: 2, //3
      }
   };

   // Dynamic Team Members Easy to Update
   let data = [
      { name: 'Miika Jukakoski', designation: t('CTO'), photo: 'miika.png', email: 'miika.jukakoski@ourmind.io', linkedin: 'https://www.linkedin.com/in/miika-jukakoski' },
    /*   { name: 'Jarmo Piipponen', designation: t('CEO'), photo: 'jarmo.png', email: 'jarmo.piipponen@ourmind.io', linkedin: 'https://www.linkedin.com/in/jarmo-piipponen-0a367a' }, */
      { name: 'Vilho Halonen', designation: t('Data Scientist'), email: 'vilho.halonen@ourmind.io', photo: 'vilho.jpg' }
   ];

   // Dynamic Team Members Data Loop
   let DataList = data.map((val, i) => {
      return (
         <div className="team-item" key={i}>
            <div className="team-block">
               <div className="team-box">
                  <div className="team-avtar">
                     <img src={`assets/images/avtar/${val.photo}`} alt="" />
                  </div>
                  <div className="team-text">
                     <h3>{val.name}</h3>
                     <h6>{val.designation}</h6>
                  </div>
                  <div className="overlay">
                     <ul className="team-social">
                        {val.email ? <li><a href={`mailto: ${val.email}`}><i className="fa fa-envelope"></i></a></li> : ''}
                        {val.linkedin ? <li><a href={val.linkedin} target="_blank"><i className="fa fa-linkedin"></i></a></li> : ''}
                     </ul>
                  </div>
               </div>
            </div>
         </div>
      );
   });

   return (
      <section id="team" className="team">
         <div className="team-decor">
            <div className="team-circle1"><img src="assets/images/team1.png" alt="" /></div>
            <div className="team-circle2"><img src="assets/images/team3.png" alt="" /></div>
            <div className="team-circle3"><img src="assets/images/team.png" alt="" /></div>
         </div>
         <div className="container">
            <div className="row ">
               <div className="col-sm-12">
                  <h2 className="title pink-title"><span>ourmind</span> {t('contacts')}</h2>
               </div>
               <div className="col-sm-12">
                  <div>
                     <OwlCarousel
                        className="team-carousel owl-carousel owl-theme"
                        lazyLoad={true}
                        loop={true}
                        margin={30}
                        nav={false}
                        dots={true}
                        responsive={options}
                     >
                        {DataList}
                     </OwlCarousel>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}

export default Team;


// WEBPACK FOOTER //
// ./src/components/team.js